module.exports = __webpack_public_path__ + "img/bx-class-nickname-active.25004594.svg";